/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { combineReducers } from 'redux';
import ContactTypeReducer from '../../../Modules/contactType/store/reducer';
import ClientReducer from '../../../Modules/Maintain/client/store/reducer';
import GroupReducer from '../../../Modules/Maintain/group/store/group-reducer';
import ManufacturerReducer from '../../../Modules/Maintain/Manufacturer/store/ManufacturerReducre';
import PlanReducer from '../../../Modules/Maintain/Plan/store/reducer';
import TBillTableReducer from '../../../Modules/Maintain/tBillRates/store/reducer';
import CodeTableReducer from '../../../Modules/System/codeTables/store/reducer';
import PriceTypeReducer from '../../../Modules/System/priceType/store/reducer';
import ProcedureResultReducer from '../../../Modules/System/ProcedureResult/store/reducer';
import UserDefaultReducer from '../../../Modules/System/UserDefault/store/reducer';
import LetterTemplateReducer from '../../../Modules/Maintain/LetterTemplate/store/reducer';

import CmsReducer from '../../../Modules/CMS/MaintainMATDrug/store/reducer';
import MaintainRebateReducer from '../../../Modules/Maintain/RebateProgram/MaintainRebate/store/reducer';
import CreateRebateReducer from '../../../Modules/Maintain/RebateProgram/CreateRebate/store/reducer';
import ClaimReducer from '../../../Modules/Display/Claim/store/reducer';
import DisplayInvoiceReducer from '../../../Modules/Display/invoice/store/reducer';
import NDCReducer from '../../../Modules/Display/NDC/store/reducer';
import ProviderReducer from '../../../Modules/Display/Provider/store/reducer';
import ReqInvoiceCalcReducer from '../../../Modules/Invoice/RequestInvoiceCalculation/Store/reducer';
import ReqURACalcReducer from '../../../Modules/Invoice/RequestURACalculation/Store/reducer';
import CreateUtilizationTapeReducer from '../../../Modules/Invoice/CreateUtilizationTape/Store/reducer';
import CheckReducer from '../../../Modules/Maintain/Check/store/reducers';
import SystemProviderReducer from '../../../Modules/System/systemParameter/store/reducer';
import CheckLogReducer from '../../../Modules/Tasks/LogCheck/store/Reducer';
import CalculateInterestReducer from '../../../Modules/Tasks/CalculateInterest/store/Reducer';
import SharedReducer from '../Actions/SharedReducer';
import ClaimDetailsReducer from '../../../Modules/Display/ClaimDetails/store/reducer';
import CommentsReducer from '../../../Modules/System/commentsAndCorrespondence/store/reducers';
import DrugFamilySearchReducer from '../../../Modules/Maintain/DrugFamily/DrugFamilySearch/store/reducer';
import DrugFamilyDetailsReducer from '../../../Modules/Maintain/DrugFamily/DrugFamilyDetails/store/reducer';
import RebatePgmReducer from '../../../Modules/Maintain/RebateProgram/store/reducer';
import SearchRebateReducer from '../../../Modules/Maintain/RebateProgram/SearchRebate/store/reducer';
import RecordMailingDateReducer from '../../../Modules/Invoice/RecordMailingDate/Store/reducer';
import FreezeInvoiceReducer from '../../../Modules/Invoice/FreezeInvoice/Store/reducer';
import ExcludedNDCsReducer from '../../../Modules/Maintain/excludedNDCs/store/reducer';
import IneligibleProvidersReducer from '../../../Modules/Maintain/IneligibleProviders/Store/reducer';
import UnitConversionReducer from '../../../Modules/Maintain/unitConversion/store/reducer';
import AssignDisputesDetailReducer from '../../../Modules/Tasks/AssignDisputesDetail/store/reducer';
import AssignDisputesSearchReducer from '../../../Modules/Tasks/AssignDisputesSearch/store/reducer';
import LogBatchTotalReducer from '../../../Modules/Tasks/LogBatchTotal/store/reducer';
import RequestClaimReducer from '../../../Modules/Tasks/RequestClaimAudit/store/reducer';
import CheckByInvoiceReducer from '../../../Modules/Tasks/CheckByInvoices/store/reducer';
import RequestMailingReducer from '../../../Modules/Tasks/MailingLabelRequest/store/reducer';
import LabelerDifferencesReducer from '../../../Modules/Research/LabelerDifferences/store/reducer';
import DisplayCheckReducer from '../../../Modules/Display/Check/store/reducer';
import InvoiceAuditsReducer from '../../../Modules/Research/InvoiceAudits/store/Reducer';
import UnfreezeInvoiceReducer from '../../../Modules/System/TechnicalWindow/OnlineFixes/UnfreezeInvoice/Store/reducer';
import RemoveSuspendedDtReducer from '../../../Modules/System/TechnicalWindow/OnlineFixes/RemoveSuspendedDt/Store/reducer';
import ContractReducer from '../../../Modules/Maintain/Contract/store/reducers';
import CMSMismatchReducer from '../../../Modules/Research/CMSMismatch/store/reducer';
import CMSRosiReducer from '../../../Modules/Research/CMSROSI/store/Reducer';
import ContactAnomaliesReducer from '../../../Modules/Research/ContactAnomalies/store/Reducer';
import LinkNewDrugsReducer from '../../../Modules/Tasks/LinkNewDrugsToDrugFamily/store/reducer';
import DeleteCheckLogReducer from '../../../Modules/System/TechnicalWindow/OnlineFixes/DeleteCheckLog/store/reducer';
import RequestedPreviousClaimReducer from '../../../Modules/System/TechnicalWindow/OnlineFixes/RequestedPreviousClaim/store/reducer';
import QuarterlyPaymentReducer from '../../../Modules/Reports/QuarterlyPayment/store/reducer';
import DeleteBatchReducer from '../../../Modules/System/TechnicalWindow/OnlineFixes/RequestDeleteBatch/store/reducer';
import CreateStubInvoiceReducer from '../../../Modules/System/TechnicalWindow/OnlineFixes/CreateStubInvoice/store/reducer';
import showPreLoader from '../../../interceptor/store/Reducer';
import RequestPriceLoadReducer from '../../../Modules/Invoice/RequestDrugPriceLoad/store/reducer';
import LetterReducer from '../../../Modules/Display/Letter/store/Reducer';
import ClaimAuditReducer from '../../../Modules/Research/ClaimAudits/store/reducer';
import DisputesReducer from '../../../Modules/Research/Disputes/store/reducer';
import GeneratecdReducer from '../../../Modules/Tasks/GenerateCollectionLetter/store/reducer';
import CMSROSIPQASReducer from '../../../Modules/Research/CMSRPInconsistencies/store/reducer';
import CMSDrugFileReducer from '../../../Modules/Research/CMSDrugFileDiscrepancies/store/Reducer';
import ViewCheckAllocation from '../../../Modules/Tasks/ViewCheckAllocation/store/reducer';
import UnderThresholdInvoiceReducer from '../../../Modules/Research/UnderThresholdInvoices/store/reducer';
import PriceLevel from '../../../Modules/Maintain/RebatePriceLevel/store/reducers';
import SuspendedCheckReducer from '../../../Modules/Research/SuspendedChecks/store/Reducer';
import CreateLetterReducer from '../../../Modules/Tasks/CreateLetter/store/reducer';
import ProviderReviewReducer from '../../../Modules/Tasks/ProviderReview/Store/reducer';
import AccountRecReducer from '../../../Modules/Research/AccountReceivable/ReqAccReceivable/store/reducer';
import ArSmryMfgAllReducer from '../../../Modules/Research/AccountReceivable/ARSummaryByMfgAll/store/reducer';
import ArSummaryMfgReducer from '../../../Modules/Research/AccountReceivable/ARSummaryByMfg/store/reducer';
import ARManufacturerReducer from '../../../Modules/Research/AccountReceivable/ARManufacturer/store/reducer';
import ArSummaryQtrAllReducer from '../../../Modules/Research/AccountReceivable/ARSummaryByQtrAll/store/reducer';
import ArSummaryQtrReducer from '../../../Modules/Research/AccountReceivable/ARSummaryByQtr/store/reducer';
import ManufacturerArReducer from '../../../Modules/Research/AccountReceivable/MfgAccountsRec/store/reducer';
import AccRecNDCActivityReducer from '../../../Modules/Research/AccountReceivable/AccRecNDCActivity/store/reducer';
import AccRecNDCDetailReducer from '../../../Modules/Research/AccountReceivable/AccRecNDCDetail/store/reducer';
import AccRecNDCDetailAllReducer from '../../../Modules/Research/AccountReceivable/AccRecNDCDetailAll/store/reducer';
import QtrAccountsRecReducer from '../../../Modules/Research/AccountReceivable/QtrAccountsRec/store/reducer';
import QtrAccountsRecAllReducer from '../../../Modules/Research/AccountReceivable/QtrAccountsRecAll/store/reducer';
import PerformDisputeResolutionReducer from '../../../Modules/Tasks/PerformDisputeResolutions/store/reducer';
import TransitionData from '../../../Modules/System/TechnicalWindow/TransitionData/store/reducer';
import PriceDetails from '../../../Modules/Maintain/RebatePriceDetails/store/reducer';
import PeriodicReportReducer from '../../../Modules/System/TechnicalWindow/PeriodicReport/store/reducer';
import QuarterlyMarketingDataReducer from '../../../Modules/System/TechnicalWindow/QuarterlyMarketingData/store/reducer';
import GenerateInvoiceReducer from '../../../Modules/Invoice/GenerateInvoice/store/Reducer';
import PaymentSummaryReducer from '../../../Modules/Reports/PaymentSummary/Store/reducer';
import RebateSummaryReducer from '../../../Modules/Reports/summaryReports/store/reducer';
import DrugSummaryReducer from '../../../Modules/Reports/DrugTypeSummary/store/reducer';
import AllocatePaymentReducer from '../../../Modules/Tasks/AllocatePayments/store/Reducer';
import AllocatePaymentReducer2 from '../../../Modules/Tasks/AllocatePayments/PQASTab/store/Reducer';
import RebatePercentOfSpendReducer from '../../../Modules/Reports/RebatePercentOfSpend/Store/reducer';
import PercentManufacturerReducer from '../../../Modules/Reports/RebatePercentOfSpend/Store/reducer';
import InvoiceRegisterReducer from '../../../Modules/Reports/InvoiceRegister/Store/reducer';
import UnallocatedBalanceReducer from '../../../Modules/Reports/UnallocatedReports/store/reducer';
import CreateCmsReportReducer from '../../../Modules/System/TechnicalWindow/OnlineFixes/ReqInitCorrectCmsReport/Store/reducer';
import URASearchReducer from '../../../Modules/Display/URASearch/store/reducer';
import CalculatedInterestReducer from '../../../Modules/Display/CalculatedInterest/store/reducer';
import TopBalancesReducer from '../../../Modules/Reports/TopBalances/Store/reducer';
import InvoicesforQtrnotPaidReducer from '../../../Modules/Reports/InvoicesQtrnitPaid/store/reducer';
import CurrentZeroURAReducer from '../../../Modules/Reports/CurrentZeroURA/Store/reducer';
import QuarterlyPaymentsReducer from '../../../Modules/Reports/QuarterlyPayments/Store/reducer';
import HcpcsCodeClaimsPaidReducer from '../../../Modules/Reports/HcpcsCodeClaimsPaid/Store/Reducer';
import DisputeActivityReducer from '../../../Modules/Reports/DisputeActivity/Store/reducer';
import InterestOverrideReducer from '../../../Modules/Reports/InerestOverride/Store/reducer';
import DisputeAmountReducer from '../../../Modules/Reports/DisputeAmmount/Store/reducer';
import CGPReducer from '../../../Modules/System/claimGroupingParameter/store/reducer';
import CheckAllocationComparisionReducer from '../../../Modules/Reports/CheckAllocationComparison/Store/reducer';
import NDCDetailsReducer from '../../../Modules/Reports/NDCDetails/Store/reducer';
import ZeroURAReducer from '../../../Modules/Reports/ZeroURA/Store/reducer';
import InterestRecievedReducer from '../../../Modules/Reports/InterestRecieved/Store/reducer';
import DisputeRecapReducer from '../../../Modules/Reports/DisputeRecapitulation/Store/reducer';
import OutstandingDisputesNumOfDaysReducer from '../../../Modules/Reports/OutstandingDisputesForNumOfDays/Store/reducer';
import OutstandingDisputesForQuarterReducer from '../../../Modules/Reports/OutstandingDisputesForQuarter/Store/reducer';
import NDCHistoryReducer from '../../../Modules/Reports/NDCHistory/Store/reducer';
import AdjustmentReasonCodeReducer from '../../../Modules/Reports/AdjustmentByReasonCode/Store/reducer';
import InstitutionalClaimsReducer from '../../../Modules/Reports/InstitutionalClaimUnitTypeDiscrepancy/Store/reducer';
import ContractReportReducer from '../../../Modules/Reports/Contract/Store/reducer';
import DisputeCodeReducer from '../../../Modules/Reports/DisputeCodes/Store/reducer';
import RosiReducer from '../../../Modules/Reports/RosiPqas/Store/reducer';
import QuarterlyCmsReducer from '../../../Modules/Reports/CmsUroa/Store/reducer';
import QuarterlyCmsDrugReducer from '../../../Modules/Reports/CmsDrug/Store/reducer';
import BProviderClaimReducer from '../../../Modules/Reports/ProviderClaim/Store/reducer';
import InvoiceReportReducer from '../../../Modules/Display/InvoiceReport/store/reducer';
import ProgramEligibilityReducer from '../../../Modules/Reports/ProgramAndEligibility/Store/reducer';
import TotalDollerPaidReducer from '../../../Modules/Reports/TotalDollersPaid/Store/reducer';
import PreInvoiceReducer from '../../../Modules/Reports/PreInvoiceUnitAdjustment/Store/reducer';
import CurrentPreviousQuarter from '../../../Modules/Reports/CurrentToPreviousQuarter/Store/reducer';
import MCOClaimsReducer from '../../../Modules/Reports/MCOClaims/Store/Reducer';
import CashReceiptSummaryReducer from '../../../Modules/Reports/CashReceiptSummary/Store/reducer';
import CmsAdjustReducer from '../../../Modules/Reports/CmsReportAdjustment/Store/reducer';
import AdjustedClaimReducer from '../../../Modules/Reports/AdjustedClaims/Store/reducer';
import OutstandingBalanceByLabererAndQuarterReducer from '../../../Modules/Reports/OutstandingBalanceByLabererAndQuarter/Store/Reducer';
import NDCPaymentReducer from '../../../Modules/Reports/NDCPayment/Store/reducer';
import FamilyPlanningDrugsInvReducer from '../../../Modules/Reports/FamilyPlanningDrugsInvoicedforRebates/Store/Reducer';
import FamilyPlanningDrugsPmtRecReducer from '../../../Modules/Reports/FamilyPlanningDrugsPaymentReceived/Store/Reducer';
import ExcludedClaimReducer from '../../../Modules/Reports/ExcludedClaims/Store/reducer';
import ManufacturerSummaryReducer from '../../../Modules/Reports/ManufacturerSummary/Store/reducer';
import UserListReducer from '../../../Modules/System/UserList/Store/reducer';
import ChipCshcnRatesReducer from '../../../Modules/Reports/ChipCshcnRates/Store/reducer';
import QuarterlyClaimsReconcilliationReducer from '../../../Modules/Reports/QuarterlyClaimsReconcilliation/Store/reducer';
import MonthlyClaimsReconcilliationReducer from '../../../Modules/Reports/MonthlyClaimsReconcilliation/Store/reducer';
import EventLoggingReducer from '../../../Modules/System/EventLogging/store/reducer';

import ActiveReducer from '../../../Modules/Reports/ActiveLabeler/Store/reducer';
import TerminatedLabelerReducer from '../../../Modules/Reports/TerminatedLabeler/Store/reducer';
import DrugsTherapeuticClassReducer from '../../../Modules/Reports/DrugsTherapeuticClass/Store/Reducer';
import ChipCshcnRateAuditReducer from '../../../Modules/Reports/ChipCshcnRateAudit/Store/reducer';
import SupplementalReducer from '../../../Modules/Reports/SupplementalRates/Store/reducer';
import AdjustmentReducer from '../../../Modules/Reports/UnitAdjustmentatNDCLevel/Store/reducer';
import ManufacturerOutstandingBalanceReducer from '../../../Modules/Reports/ManufacturerOutstandingBalance/Store/Reducer';
import SubstanceReducer from '../../../Modules/Reports/SubstanceAbuse/Store/reducer';
import DProviderClaimReducer from '../../../Modules/Reports/DProviderClaim/Store/reducer';
import RiderReducer from '../../../Modules/Reports/Rider/Store/reducer';
import NumberOfUnits from '../../../Modules/Maintain/NumberOfUnits/store/reducer';
import CMSQuarterlyReducer from '../../../Modules/CMS/CMSQuarterlyReporting/Store/reducer';
import TableGridReducer from '../../Table/store/Reducer';
import DashboardReducer from '../../Dashboard/store/reducer';
import ReminderRecipientReducer from '../../../Modules/System/ReminderRecipients/store/Reducer';
import AddorDeleteLoadLogEmailReducer from '../../../Modules/System/AddorDeleteLoadLogEmail/store/reducer';
import UpdateParamGeneralReducer from '../../../Modules/System/UpdateParamGeneral/store/reducer';
import ReminderSetupReducer from '../../../Modules/System/ReminderSetup/store/reducer';
import SystemReminderReducer from '../../../Modules/System/SystemReminder/store/Reducer';
import DataNicheReportReducer from '../../../Modules/Tasks/RequestDataNicheReport/Store/Reducer';
import IneligibleCPTReducer from '../../../Modules/Maintain/MaintainIneligibleCPT/Store/Reducer';

const rootReducer = combineReducers({
  ProcedureResultReducer: ProcedureResultReducer,
  ContactTypeReducer: ContactTypeReducer,
  UserDefaultReducer: UserDefaultReducer,
  CodeTableReducer: CodeTableReducer,
  TBillTableReducer: TBillTableReducer,
  PriceTypeReducer: PriceTypeReducer,
  GroupReducer: GroupReducer,
  PlanReducer: PlanReducer,
  AccountRecReducer: AccountRecReducer,
  ArSmryMfgAllReducer: ArSmryMfgAllReducer,
  ManufacturerArReducer: ManufacturerArReducer,
  ARManufacturerReducer: ARManufacturerReducer,
  AccRecNDCActivityReducer: AccRecNDCActivityReducer,
  AccRecNDCDetailReducer: AccRecNDCDetailReducer,
  AccRecNDCDetailAllReducer: AccRecNDCDetailAllReducer,
  QtrAccountsRecReducer: QtrAccountsRecReducer,
  QtrAccountsRecAllReducer: QtrAccountsRecAllReducer,
  ArSummaryMfgReducer: ArSummaryMfgReducer,
  ArSummaryQtrReducer: ArSummaryQtrReducer,
  ArSummaryQtrAllReducer: ArSummaryQtrAllReducer,
  ManufacturerReducer: ManufacturerReducer,
  ProviderReducer: ProviderReducer,
  SystemProviderReducer: SystemProviderReducer,
  DisplayInvoiceReducer: DisplayInvoiceReducer,
  UnitConversionReducer: UnitConversionReducer,
  ExcludedNDCsReducer: ExcludedNDCsReducer,
  ClientReducer: ClientReducer,
  claim: ClaimReducer,
  LetterTemplateReducer: LetterTemplateReducer,
  ndc: NDCReducer,
  ReqInvoiceCalcReducer: ReqInvoiceCalcReducer,
  ReqURACalcReducer: ReqURACalcReducer,
  CreateUtilizationTapeReducer: CreateUtilizationTapeReducer,
  CheckReducer: CheckReducer,
  MaintainRebateReducer: MaintainRebateReducer,
  CreateRebateReducer: CreateRebateReducer,
  RebatePgmReducer: RebatePgmReducer,
  SearchRebateReducer: SearchRebateReducer,
  CheckLogReducer: CheckLogReducer,
  AssignDisputesSearchReducer: AssignDisputesSearchReducer,
  AssignDisputesDetailReducer: AssignDisputesDetailReducer,
  DrugFamilySearchReducer: DrugFamilySearchReducer,
  DrugFamilyDetailsReducer: DrugFamilyDetailsReducer,
  RecordMailingDateReducer: RecordMailingDateReducer,
  FreezeInvoiceReducer: FreezeInvoiceReducer,
  SharedReducer: SharedReducer,
  RequestClaimReducer: RequestClaimReducer,
  IneligibleProvidersReducer: IneligibleProvidersReducer,
  LogBatchTotalReducer: LogBatchTotalReducer,
  ClaimDetailsReducer: ClaimDetailsReducer,
  CommentsReducer: CommentsReducer,
  CheckByInvoiceReducer: CheckByInvoiceReducer,
  CmsReducer: CmsReducer,
  RequestMailingReducer: RequestMailingReducer,
  LabelerDifferencesReducer: LabelerDifferencesReducer,
  displayCheck: DisplayCheckReducer,
  InvoiceAuditsReducer: InvoiceAuditsReducer,
  UnfreezeInvoiceReducer: UnfreezeInvoiceReducer,
  RemoveSuspendedDtReducer: RemoveSuspendedDtReducer,
  ContractReducer: ContractReducer,
  LinkNewDrugsReducer: LinkNewDrugsReducer,
  CMSMismatchReducer: CMSMismatchReducer,
  CMSRosiReducer: CMSRosiReducer,
  ContactAnomaliesReducer: ContactAnomaliesReducer,
  CalculateInterestReducer: CalculateInterestReducer,
  deleteCheckLog: DeleteCheckLogReducer,
  requestedPreviousClaim: RequestedPreviousClaimReducer,
  deleteBatch: DeleteBatchReducer,
  requestDrugPriceLoad: RequestPriceLoadReducer,
  createStubInvoice: CreateStubInvoiceReducer,
  showPreLoader,
  ClaimAuditReducer: ClaimAuditReducer,
  DisputesReducer: DisputesReducer,
  GeneratecdReducer: GeneratecdReducer,
  CMSDrugFileReducer: CMSDrugFileReducer,
  ViewCheckAllocation: ViewCheckAllocation,
  UnderThresholdInvoiceReducer: UnderThresholdInvoiceReducer,
  PriceLevel,
  SuspendedCheckReducer: SuspendedCheckReducer,
  CMSROSIPQASReducer: CMSROSIPQASReducer,
  CreateLetterReducer: CreateLetterReducer,
  ProviderReviewReducer: ProviderReviewReducer,
  PerformDisputeResolutionReducer: PerformDisputeResolutionReducer,
  LetterReducer: LetterReducer,
  TransitionData,
  PriceDetails: PriceDetails,
  PeriodicReportReducer,
  QuarterlyMarketingDataReducer: QuarterlyMarketingDataReducer,
  RebateSummaryReducer: RebateSummaryReducer,
  GenerateInvoiceReducer: GenerateInvoiceReducer,
  QuarterlyPaymentReducer: QuarterlyPaymentReducer,
  PaymentSummaryReducer: PaymentSummaryReducer,
  RebatePercentOfSpendReducer: RebatePercentOfSpendReducer,
  PercentManufacturerReducer: PercentManufacturerReducer,
  InvoiceRegisterReducer: InvoiceRegisterReducer,
  InvoicesforQtrnotPaidReducer: InvoicesforQtrnotPaidReducer,
  TopBalancesReducer: TopBalancesReducer,
  UnallocatedBalanceReducer: UnallocatedBalanceReducer,
  CreateCmsReportReducer: CreateCmsReportReducer,
  URASearchReducer: URASearchReducer,
  DrugSummaryReducer: DrugSummaryReducer,
  DisputeAmountReducer: DisputeAmountReducer,
  AllocatePaymentReducer: AllocatePaymentReducer,
  AllocatePaymentReducer2: AllocatePaymentReducer2,
  CurrentZeroURAReducer: CurrentZeroURAReducer,
  QuarterlyPaymentsReducer: QuarterlyPaymentsReducer,
  HcpcsCodeClaimsPaidReducer: HcpcsCodeClaimsPaidReducer,
  DisputeActivityReducer: DisputeActivityReducer,
  InterestOverrideReducer: InterestOverrideReducer,
  CGPReducer: CGPReducer,
  CheckAllocationComparisionReducer: CheckAllocationComparisionReducer,
  NDCDetailsReducer: NDCDetailsReducer,
  ZeroURAReducer: ZeroURAReducer,
  InterestRecievedReducer: InterestRecievedReducer,
  DisputeRecapReducer: DisputeRecapReducer,
  OutstandingDisputesNumOfDaysReducer: OutstandingDisputesNumOfDaysReducer,
  OutstandingDisputesForQuarterReducer: OutstandingDisputesForQuarterReducer,
  NDCHistoryReducer: NDCHistoryReducer,
  AdjustmentReasonCodeReducer: AdjustmentReasonCodeReducer,
  InstitutionalClaimsReducer: InstitutionalClaimsReducer,
  ContractReportReducer,
  DisputeCodeReducer: DisputeCodeReducer,
  RosiReducer: RosiReducer,
  QuarterlyCmsReducer: QuarterlyCmsReducer,
  QuarterlyCmsDrugReducer: QuarterlyCmsDrugReducer,
  BProviderClaimReducer: BProviderClaimReducer,
  InvoiceReportReducer: InvoiceReportReducer,
  ProgramEligibilityReducer: ProgramEligibilityReducer,
  TotalDollerPaidReducer: TotalDollerPaidReducer,
  PreInvoiceReducer: PreInvoiceReducer,
  CurrentPreviousQuarter: CurrentPreviousQuarter,
  CmsAdjustReducer: CmsAdjustReducer,
  MCOClaimsReducer: MCOClaimsReducer,
  CashReceiptSummaryReducer: CashReceiptSummaryReducer,
  OutstandingBalanceByLabererAndQuarterReducer:
    OutstandingBalanceByLabererAndQuarterReducer,
  NDCPaymentReducer: NDCPaymentReducer,
  ExcludedClaimReducer: ExcludedClaimReducer,
  CalculatedInterestReducer,
  FamilyPlanningDrugsInvReducer: FamilyPlanningDrugsInvReducer,
  FamilyPlanningDrugsPmtRecReducer: FamilyPlanningDrugsPmtRecReducer,
  ManufacturerSummaryReducer,
  AdjustedClaimReducer: AdjustedClaimReducer,
  UserListReducer: UserListReducer,
  ChipCshcnRatesReducer: ChipCshcnRatesReducer,
  ActiveReducer: ActiveReducer,
  QuarterlyClaimsReconcilliationReducer,
  MonthlyClaimsReconcilliationReducer,
  DrugsTherapeuticClassReducer: DrugsTherapeuticClassReducer,
  ChipCshcnRateAuditReducer: ChipCshcnRateAuditReducer,
  AdjustmentReducer: AdjustmentReducer,
  SupplementalReducer: SupplementalReducer,
  TerminatedLabelerReducer: TerminatedLabelerReducer,
  ManufacturerOutstandingBalanceReducer: ManufacturerOutstandingBalanceReducer,
  SubstanceReducer: SubstanceReducer,
  DProviderClaimReducer: DProviderClaimReducer,
  RiderReducer,
  CMSQuarterlyReducer: CMSQuarterlyReducer,
  NumberOfUnits: NumberOfUnits,
  EventLoggingReducer: EventLoggingReducer,
  TableGridReducer: TableGridReducer,
  DashboardReducer: DashboardReducer,
  ReminderRecipientReducer: ReminderRecipientReducer,
  AddorDeleteLoadLogEmailReducer: AddorDeleteLoadLogEmailReducer,
  UpdateParamGeneralReducer: UpdateParamGeneralReducer,
  ReminderSetupReducer: ReminderSetupReducer,
  SystemReminderReducer: SystemReminderReducer,
  DataNicheReportReducer: DataNicheReportReducer,
  IneligibleCPTReducer: IneligibleCPTReducer,
});

export default rootReducer;
